import { Fragment, h } from 'preact'
import { useLayoutEffect } from 'preact/hooks'
import { BanniereHTML } from '../../components/banniere-html/banniere-html.jsx'
import { BanniereImage } from '../../components/banniere-image/banniere-image.jsx'
import { glideInit } from '../../js/componentsOrchestrator/carrouselOrchestrator.js'

export const Carrousel = ({ format, slides }) => {
   useLayoutEffect(() => {
      glideInit(slides.length)

      //Affichage mention légales
      let showButton = document.querySelectorAll('.showButton')
      showButton.forEach((el) => {
         el.addEventListener('keydown', function (event) {
            const keyD = event.key !== undefined ? event.key : event.code
            if (keyD === 'Enter' || keyD === 13 || ['Spacebar', ' '].indexOf(keyD) >= 0 || keyD === 32) {
               event.preventDefault()
               this.click()
            }
         })
      })
   }, [])

   return (
      <section class="row no-gutters">
         <div class="col-12">
            <h2 class="sr-only">L'actualité des offres, produits et services</h2>
            <div id="zone_top_carrousel" data-testid={`${format.startsWith('tv') || format.startsWith('prospect')  ? 'carrousel' : 'bande-carrousel'}`} class={`glide glide-carousel glide-carousel-${format}`}>
               <div class="glide__track" data-glide-el="track">
                  <div class="glide__slides">
                     {slides.map((slide, index) => {
                        return (
                           <div class="glide__slide" data-slidenb={index}>
                              {slide.componentName === 'BanniereImage' ? <BanniereImage {...slide.datas} /> : <BanniereHTML {...slide.datas} />}
                           </div>
                        )
                     })}
                  </div>
               </div>

               {slides.length > 1 ? <Navigation slides={slides} /> : null}
            </div>
         </div>
      </section>
   )
}

const Navigation = ({ slides }) => {
   return (
      <Fragment>
         <div class="glide__arrows">
            <button class="glide__arrow glide__arrow--left" data-glide-dir="<" aria-label="précédent" tabindex="-1">
               <span class="icon-arrow-previous" aria-hidden="true"></span>
            </button>
            <button class="glide__arrow glide__arrow--right" data-glide-dir=">" aria-label="suivant" tabindex="-1">
               <span class="icon-arrow-next" aria-hidden="true"></span>
            </button>
         </div>

         <div class="glide__bullets" data-glide-el="controls[nav]">
            {slides.map((slide, index) => {
               return (
                  <div class="glide__bullet" data-glide-dir={`=${index}`} aria-hidden="true">
                     <span></span>
                  </div>
               )
            })}
         </div>

         <button type="button" class="glide__playpause glide__playpause--pause" aria-label="Mettre en pause le carrousel"></button>
      </Fragment>
   )
}
